// @owners { team: patients-team }
import { Illustration } from '@alto/design-system';
import React from 'react';
import { getImage } from '~shared/assets/images/getImage';
import { IMG_ALT_TEXTS } from '~shared/constants';

export const BagWithMedicationsImage = () => {
  return (
    <Illustration
      size="xl"
      source={getImage('bagWithMedications')}
      accessibilityLabel={IMG_ALT_TEXTS.bagWithMedications}
      testID={'med-bag-image'}
    />
  );
};
